// extracted by mini-css-extract-plugin
export default {"header":"header_opx7F","headerButton":"headerButton_RNcEM","headerTitle":"headerTitle_YhgG8","title":"title_AKIJ2","icon":"icon_TcXid","container":"container_Ha79x"};